import {Datagrid, DateField, FunctionField, Record, TextField} from "react-admin";
import {DatagridPropsWithOptions} from "../../shared/types";
import {formatEuro, initField} from "../../shared/utils";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";


const LongTextCell = ({ text }:{ text:string }) => (
  <TableCell 
    style={{ 
      whiteSpace: 'normal', 
      wordWrap: 'break-word',
      maxWidth: '80px'  
    }}
  >
    <Typography variant="body2">
      {text}
    </Typography>
  </TableCell>
);


const ImportCell = ({ amount, type }: { amount: number, type: string }) => {
  if (type === "I") {
    return <Typography style={{ color: "green" }}>+ {formatEuro(amount)}</Typography>
  } else {
    return <Typography color="primary">- {formatEuro(amount)}</Typography>
  }
}


export const ReconciliationDatagrid = ({
  options,
  ...rest
}: DatagridPropsWithOptions) => {


  return options ? (
    <Datagrid {...rest} style={{ "overflow": "auto" }}>
      <TextField {...initField("id", options)} />
      <FunctionField render={function (record?: Record | undefined, source?: string) {
        return record && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Prima nota: {record.journal_entry.length}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Id</TableCell>
                      <TableCell>Descrizione</TableCell>
                      <TableCell>Importo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {record.journal_entry.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <LongTextCell text={row.description} />
                        <TableCell><ImportCell amount={row.amount} type={row.journal_type}/></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        )
      }} label="Prima nota" />

      <FunctionField render={function (record?: Record | undefined, source?: string) {
        return record && (
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Riga file: {record.reconciliation_file_row.length}</Typography>
            </AccordionSummary>
            <AccordionDetails>
            <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Id</TableCell>
                      <TableCell>Descrizione</TableCell>
                      <TableCell>Importo</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {record.reconciliation_file_row.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell component="th" scope="row">
                          {row.id}
                        </TableCell>
                        <LongTextCell text={row.description} />
                        <TableCell><ImportCell amount={row.value} type={row.row_type}/></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </AccordionDetails>
          </Accordion>
        )

      }} label="Riga file" />
      <DateField {...initField("date", options)} />
    </Datagrid>
  ) : null;
};